"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _index = require("@/utils/index");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/** utils */
var _default2 = exports.default = {
  props: {
    lookupList: {
      type: Object,
      default: function _default() {
        return {
          STORE_RTM_TYPE_MAPPING: ''
        };
      }
    },
    form: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    show: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'view'
    },
    rules: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    // 是否潜在客户
    isQzkh: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {};
  },
  watch: {
    isLoading: function isLoading(newValue) {
      // pc unlock 锁屏会导致页面晃动
      if (newValue) {
        this.loadingComponent = this.$loading({
          // lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0)'
        });
      } else {
        if (this.loadingComponent) {
          this.loadingComponent.close();
        }
      }
    }
  },
  methods: {
    // 格式化 零售店类别
    formatRType: function formatRType(key) {
      return (0, _index.formatKeyValue)(key, this.lookupList['Retailer_Type_description']);
    }
  }
};